export default __webpack_public_path__ + "static/media/Feature1.9577acee.svg";